/*----------------------
       ARTICLE HERO
---------------------- */
ArticleHero = {
    init: function () {
        if (!$(".article-hero__gallery__slider").length) return;

        var $slider = $(".article-hero__gallery__slider");
        var $swiper = $slider.find(".swiper-article-hero");
        var slideCount = $swiper.find(".swiper-slide").length;

        if (slideCount < 2) return;

        new Swiper($swiper[0], {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: $slider.find(".btn--next")[0],
                prevEl: $slider.find(".btn--prev")[0],
            },
        });
    },
};


$(document).ready(function () {
    ArticleHero.init();
});